const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
};

// Pub/Sub system for component communication
const subscribers = {};

function subscribe(event, callback) {
  if (!subscribers[event]) {
    subscribers[event] = [];
  }
  subscribers[event].push(callback);

  // Return unsubscribe function
  return () => {
    const index = subscribers[event].indexOf(callback);
    if (index > -1) {
      subscribers[event].splice(index, 1);
    }
  };
}

function publish(event, data) {
  if (subscribers[event]) {
    subscribers[event].forEach((callback) => callback(data));
  }
}
